import { TAG_TYPES } from '@/lib/api/tags';
import {
  buildListQueryParams,
  handledError,
  processListPage,
  processServerError,
} from '@/lib/api/listQuery';
import { notifyOnSuccess } from '@/lib/api/notifyOnSuccess';
import { MATERIAL_SEARCH_IN, MATERIAL_SORT_FIELDS } from '../constants/materials.constants';
import {
  buildMaterialDto,
  processMaterialForm,
  processMaterialRow,
} from '../mappers/materialsMappers';

const PATHS = {
  list: '/materials',
  material: (id) => `/materials/${id}`,
};

const listTag = { type: TAG_TYPES.Material, id: 'LIST' };

export const materialsEndpoints = (build) => ({
  getAccountMaterials: build.query({
    query: (params) => ({
      url: PATHS.list,
      params: buildListQueryParams(params, {
        sortFields: MATERIAL_SORT_FIELDS,
        searchIn: MATERIAL_SEARCH_IN,
      }),
    }),
    transformResponse: (dto) => processListPage(dto, 'materials', processMaterialRow),
    providesTags: (result) =>
      result
        ? [...result.rows.map((row) => ({ type: TAG_TYPES.Material, id: row.id })), listTag]
        : [listTag],
  }),

  getMaterialForm: build.query({
    query: (id) => ({ url: PATHS.material(id) }),
    transformResponse: (dto) => processMaterialForm(dto?.output?.material),
    transformErrorResponse: handledError,
    providesTags: (result, error, id) => [{ type: TAG_TYPES.Material, id }],
  }),

  createMaterial: build.mutation({
    query: (values) => ({
      url: PATHS.list,
      method: 'POST',
      body: buildMaterialDto(values),
    }),
    transformErrorResponse: processServerError,
    onQueryStarted: notifyOnSuccess('MATERIALS_SAVED'),
    invalidatesTags: [listTag],
  }),

  updateMaterial: build.mutation({
    query: ({ id, values }) => ({
      url: PATHS.material(id),
      method: 'PATCH',
      body: buildMaterialDto(values),
    }),
    transformErrorResponse: processServerError,
    onQueryStarted: notifyOnSuccess('MATERIALS_SAVED'),
    invalidatesTags: (result, error, arg) => [{ type: TAG_TYPES.Material, id: arg.id }, listTag],
  }),
});
